import React, { useState } from 'react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    try {
  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/forgotpassword`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(data.message || "If this email exists, you'll receive instructions to reset your password.");
      } else {
        setMessage(data.message || "Error sending reset email.");
      }
    } catch {
      setMessage("Error sending reset email.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Forgot Password</h2>
        <p style={styles.text}>
          To reset your password, type the full email address you used to sign up for Jaca.com and we'll send you an e-mail to walk you through resetting your password.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            style={styles.input}
          />
          <button type="submit" style={styles.button}>Submit</button>
        </form>
        {message && <div style={styles.message}>{message}</div>}
      </div>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f5f6fa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    background: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
    maxWidth: '400px',
    width: '100%',
    textAlign: 'center',
  },
  title: {
    color: '#4078c0',
    fontSize: '2rem',
    marginBottom: '18px',
  },
  text: {
    color: '#555',
    fontSize: '1rem',
    marginBottom: '24px',
  },
  input: {
    width: '100%',
    padding: '12px',
    borderRadius: '6px',
    border: '1px solid #dbe6f6',
    marginBottom: '18px',
    fontSize: '1rem',
  },
  button: {
    width: '100%',
    padding: '12px',
    borderRadius: '6px',
    background: '#4078c0',
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1rem',
    border: 'none',
    cursor: 'pointer',
  },
  message: {
    marginTop: '18px',
    color: '#4078c0',
    fontSize: '1rem',
  },
};

export default ForgotPassword;